import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";

export const containerStyle = recipe({
  base: {
    color: theme.colors.onSecondary,
    padding: theme.spacings.m,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacings.xs,
    position: "relative",
    marginBottom: rem(10),
  },
  variants: {
    arrow: {
      true: {
        selectors: {
          "&:after": {
            content: "''",
            position: "absolute",
            bottom: rem(-10),
            right: rem(20),
            width: 0,
            height: 0,
            borderLeft: `${rem(10)} solid transparent`,
            borderRight: `${rem(10)} solid transparent`,
            borderTop: `${rem(10)} solid red`,
          },
          "&:before": {
            content: "''",
            position: "absolute",
            bottom: rem(-11),
            right: rem(19),
            width: 0,
            height: 0,
            borderLeft: `${rem(11)} solid transparent`,
            borderRight: `${rem(11)} solid transparent`,
            borderTop: `${rem(11)} solid ${theme.colors.defaultBorder}`,
          },
        },
      },
    },
    variant: {
      default: {
        color: theme.colors.onBackground,
        background: theme.colors.background,
        padding: theme.spacings.s,
        border: `1px solid ${theme.colors.inputBorder}`,
        borderRadius: theme.borderRadiuses.s,
        selectors: {
          "&:after": {
            borderTopColor: theme.colors.background,
          },
          "&:before": {
            borderTopColor: theme.colors.inputBorder,
          },
        },
      },
      sideContent: {
        background: theme.colors.background,
        padding: theme.spacings.s,
        borderRadius: theme.borderRadiuses.s,
        border: `1px solid ${theme.colors.background}`,
        color: theme.colors.onBackground,
        selectors: {
          "&:after": {
            borderTopColor: theme.colors.background,
          },
          "&:before": {
            display: "none",
          },
        },
      },
      compact: {
        color: theme.colors.onBackground,
        background: theme.colors.background,
        padding: theme.spacings.s,
        border: `1px solid ${theme.colors.inputBorder}`,
        borderRadius: theme.borderRadiuses.s,
        selectors: {
          "&:after": {
            borderTopColor: theme.colors.background,
          },
          "&:before": {
            borderTopColor: theme.colors.inputBorder,
          },
        },
      },
    },
  },
});

export const timeStyle = style({
  alignSelf: "flex-end",
});

export const bodyStyle = style({
  alignSelf: "flex-start",
  wordBreak: "break-word",
});
